import { Card } from '@/shared/ui'

export const DigitalProductLandingPagesAugmentedReality = () => {
  return (
    <div className="container h-screen flex flex-col items-center justify-center">
      <Card className="lg:hidden">
        <Card.Body className="p-10 py-13 text-center">
          <span className="text-2xl font-semibold block mb-6 text-gray-900 max-w-[500px]">
            Baixe o aplicativo <b>Pinball Ville GO!RN</b> para visualizar os
            marcadores de realidade aumentada do GO!RN.
          </span>

          <img
            src="/misc/pinball-app-mockup-mobile.png"
            alt=""
            className="block w-1/2 mx-auto mb-4"
          />

          <span className="text-lg block font-semibold text-dark mb-8 text-gray-700 max-w-[500px]">
            Basta apontar a câmera do aplicativo para o marcador de realidade
            aumentada encontrado para visualizar todos os personagens de
            realidade aumentada disponíveis.
          </span>

          <div className="flex gap-6 items-center justify-center">
            <a
              href="https://apps.apple.com/br/app/pinball-ville-go-rn/id6467685203"
              target="_blank"
            >
              <img
                src="/misc/apple-store-badge.svg"
                alt=""
                className="h-[40px]"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.CriadoradeMundos.PinballVilleGORN&pli=1"
              target="_blank"
            >
              <img
                src="/misc/google-play-badge.png"
                alt=""
                style={{ height: '52px' }}
              />
            </a>
          </div>
        </Card.Body>
      </Card>

      <div className="hidden lg:flex w-full h-full items-center justify-center">
        <div className="lg:w-1/2 lg:order-2 flex flex-col justify-start pt-10 xl:pb-20">
          <span className="text-2xl font-semibold block mb-6 text-white max-w-[500px]">
            Baixe o aplicativo <b>Pinball Ville GO!RN</b> para visualizar os
            marcadores de realidade aumentada do GO!RN.
          </span>
          <span className="text-lg block text-white mb-8 max-w-[500px]">
            Basta apontar a câmera do aplicativo para o marcador de realidade
            aumentada encontrado para visualizar todos os personagens de
            realidade aumentada disponíveis.
          </span>
          <div className="flex gap-6 items-center">
            <a
              href="https://apps.apple.com/br/app/pinball-ville-go-rn/id6467685203"
              target="_blank"
            >
              <img
                src="/misc/apple-store-badge.svg"
                alt=""
                className="h-[50px]"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.CriadoradeMundos.PinballVilleGORN&pli=1"
              target="_blank"
            >
              <img
                src="/misc/google-play-badge.png"
                alt=""
                className="h-[65px]"
              />
            </a>
          </div>
        </div>
        <div className="lg:w-5/12 lg:order-1 self-end">
          <img
            src="/misc/pinball-app-mockup.png"
            alt=""
            className="w-3/4 lg:w-full lg:px-5 hidden lg:block"
          />
        </div>
      </div>
    </div>
  )
}
